import {HiViewfinderCircle} from "react-icons/hi2";
import React from "react";

export const renderMaskImage = () => (
    <div className="w-full h-full relative">
        <HiViewfinderCircle
            size={16}
            style={{bottom: 10, right: 10}}
            className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
        />
    </div>
)